/* @flow */
import SchoolEngagementBadge from './SchoolEngagementBadge';

export default SchoolEngagementBadge;
